import PropTypes from 'prop-types';
/**
 * @typedef {{[key: string]: string|number|boolean}} AppearanceSet
 * @typedef {AppearanceSet} VariantProp
 */

export default {
  /**
   * 'variant' is an optional object prop on all themable components.
   *
   * Contains an object with keys that correspond to the current component theme's allowed
   * appearances and values that correspond to the allowed values of that component.
   *
   * Since the particular keys and values depend on which theme is currently active,
   * the exact shape of variant props is not enforced using PropTypes.
   */
  propType: PropTypes.objectOf(PropTypes.oneOfType([PropTypes.string, PropTypes.number, PropTypes.bool]))
};